import { useNavigate } from "@tanstack/react-router";

export function Workflow() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-1 flex-col p-6">
      <h2 className="mb-6 text-2xl font-bold">Select workflow</h2>
      <div className="space-y-4">
        <button
          onClick={() => void navigate({ to: "/receipt" })}
          className="w-full rounded-2xl bg-blue-600 py-6 text-xl font-semibold active:bg-blue-700"
        >
          Goods Receipt
        </button>
        <button
          onClick={() => void navigate({ to: "/dispatch" })}
          className="w-full rounded-2xl bg-green-600 py-6 text-xl font-semibold active:bg-green-700"
        >
          Goods Dispatch
        </button>
        <button
          onClick={() => void navigate({ to: "/transfer" })}
          className="w-full rounded-2xl bg-purple-600 py-6 text-xl font-semibold active:bg-purple-700"
        >
          Transfer
        </button>
        <button
          onClick={() => void navigate({ to: "/lookup" })}
          className="w-full rounded-2xl bg-amber-600 py-6 text-xl font-semibold active:bg-amber-700"
        >
          Bag Lookup
        </button>
      </div>
      <p className="mt-auto pt-6 text-center text-xs text-gray-500">v1.1.14</p>
    </div>
  );
}
